import { Component, Input, NgZone, OnChanges, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';
import { GridComponent, GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { process, State, orderBy } from '@progress/kendo-data-query';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmDialog } from '../modals/confirm-dialog.component';
import { CSEService } from '../../services/cse.service';
import {
    SearchCustomerCarrierExclusionMap
} from '../../models/models';

@Component({
    selector: 'carrier-customer-exclusion-grid',
    templateUrl: './carrier-customer-exclusion-grid.component.html',
    standalone: false
})
export class CarrierCustomerExclusionGrid implements OnChanges {
    @Input() carrierID: number = 0;

    @ViewChild(GridComponent, { static: false }) public exclusionMapGrid!: GridComponent;

    public isLoading: boolean = false;
    public isEdit: boolean = false;
    public isAdd: boolean = false;

    public customerCarrierExclusionMapID: number = 0;
    public exclusionMapList: SearchCustomerCarrierExclusionMap[] = [];

    public gridData: GridDataResult = { data: [], total: 0 };
    public gridState: State = { skip: 0, take: 10, sort: [{ dir: 'desc', field: 'eventDate' }] };

    constructor(private cseService: CSEService, public dialog: MatDialog, private ngZone: NgZone) {
    }

    ngOnChanges() {
        this.getCustomerCarrierExclusionMaps();
    }

    private getCustomerCarrierExclusionMaps() {
        this.isLoading = true;
        this.cseService.getSearchCustomerCarrierExclusionMapByCarrierID(this.carrierID).subscribe(result => {
            this.isLoading = false;
            this.exclusionMapList = result.resultCollection;
            this.setGrid();
        });
    }

    private setGrid() {
        if (this.gridState.sort) this.exclusionMapList = orderBy(this.exclusionMapList, this.gridState.sort);

        this.gridData = process(this.exclusionMapList, this.gridState);
        this.fitColumns();
    }

    private fitColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.exclusionMapGrid == null) return;
            this.exclusionMapGrid.autoFitColumns();
        });
    }

    public dataStateChange(state: DataStateChangeEvent) {
        this.gridState = state;
        this.setGrid();
    }

    public edit(customerCarrierExclusionMapID: number) {
        this.customerCarrierExclusionMapID = customerCarrierExclusionMapID;
        this.isEdit = true;
        this.isAdd = false;
    }

    public delete(customerCarrierExclusionMapID: number) {
        var idx = this.exclusionMapList.findIndex(c => c.customerCarrierExclusionMapID == customerCarrierExclusionMapID);

        if (idx == null || idx < 0) return;

        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            header: 'Delete?',
            message: 'Would you like to delete this exclusion?'
        }

        const dialogRef = this.dialog.open(ConfirmDialog, dialogConfig);

        dialogRef.afterClosed().subscribe(dialogResult => {
            if (!dialogResult) return;

            this.cseService.deleteCustomerCarrierExclusionMap(customerCarrierExclusionMapID).subscribe(result => {
                this.getCustomerCarrierExclusionMaps();
            });
        });
    }

    public addNew() {
        this.customerCarrierExclusionMapID = 0;
        this.isEdit = false;
        this.isAdd = true;
    }

    public cancelEdit() {
        this.isEdit = false;
        this.isAdd = false;
        this.getCustomerCarrierExclusionMaps();
    }
}